// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// export const firebaseConfig = {
//   apiKey: "AIzaSyB3IOP9ZyT4ZqFj7xmyS0rbrT32_OxpYuc",
//   authDomain: "ec-app-react-21429.firebaseapp.com",
//   projectId: "ec-app-react-21429",
//   storageBucket: "ec-app-react-21429.appspot.com",
//   messagingSenderId: "594271596790",
//   appId: "1:594271596790:web:6354f4461f5175289d3cd7",
//   measurementId: "G-PGQNGMW6CR"
// };
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// export const firebaseConfig = {
//   apiKey: "AIzaSyBov3YOpXEvV0X0szm1pRcW5WzJ2L9yd54",
//   authDomain: "gdsc-pandacco.firebaseapp.com",
//   projectId: "gdsc-pandacco",
//   storageBucket: "gdsc-pandacco.appspot.com",
//   messagingSenderId: "54155251167",
//   appId: "1:54155251167:web:0880aa19089cd2c13fc86a",
//   measurementId: "G-28EJ2NE3H5"
// };

// export const firebaseConfig = {
//   apiKey: "AIzaSyCMhXpeGkIVzjzzXl2S8vRE5Hqi_z0yW68",
//   authDomain: "gdsc-pandacco-v2.firebaseapp.com",
//   projectId: "gdsc-pandacco-v2",
//   storageBucket: "gdsc-pandacco-v2.appspot.com",
//   messagingSenderId: "142789264949",
//   appId: "1:142789264949:web:0ac281d76392f6ba60537c",
//   measurementId: "G-LG5PCP64E3"
// };

export const firebaseConfig = {
  apiKey: "AIzaSyDgtK65A5gzCljde_QJn7SpqsZF655NtNo",
  authDomain: "pandacco.firebaseapp.com",
  projectId: "pandacco",
  storageBucket: "pandacco.appspot.com",
  messagingSenderId: "731863693588",
  appId: "1:731863693588:web:0ff6e8ce2be8275a65ea01",
  measurementId: "G-G7TQ6X8BT6"
};
